import { ReactivateModal } from '@presentation/components/templates'

type Props = {
  id: string
  onReactivate: () => void
}

const ReactivateFeriadoModal: React.FC<Props> = ({ id, onReactivate }) => {
  const modalConfigs = {
    id,
    path: '/feriados',
    nameForTitle: 'Feriado',
    onReactivate
  }

  return <ReactivateModal {...modalConfigs} />
}

export default ReactivateFeriadoModal
